import gql from 'graphql-tag';
export const COMPANIES_QUERY = gql`
  query getCompanies($lookAfter: [Any], $lookBefore: [Any], $limit: Int, $fullText: String, $filters: GroupDataFilter) {
    groupsCollection(
      lookAfter: $lookAfter
      lookBefore: $lookBefore
      limit: $limit
      sort: { field: "name", direction: ASC }
      fullText: $fullText
      filter: $filters
    ) {
      totalCount
      nextLookAfterKey
      previousLookBeforeKey
      items {
        name
        snn
        tags
        created_ts
        meta
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/providers/providers/queries.ts